/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailsDto } from './CompanyDetailsDto';
import type { ProductApprovalCompatibilityDto } from './ProductApprovalCompatibilityDto';
export type ExtendedProductApprovalDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    readonly approvalId?: number;
    productFormulation?: string;
    sheet?: string;
    cost: string;
    readonly sheetNumber?: string;
    readonly sheetNumbers?: Array<string>;
    readonly formulation?: string;
    readonly amount?: number;
    orderNumber?: string;
    remark?: string;
    processTypeIdentifier: ExtendedProductApprovalDto.processTypeIdentifier;
    readonly product?: string;
    readonly productName?: string;
    readonly sheetNameDe?: string;
    readonly sheetNameEn?: string;
    productApprovalCompatibilities?: Array<ProductApprovalCompatibilityDto>;
    readonly productTypeIdentifier?: ExtendedProductApprovalDto.productTypeIdentifier;
    readonly manufacturerDetails?: CompanyDetailsDto;
    operatingFluidTypeId: string;
    clientDetails?: CompanyDetailsDto;
    productApprovalState?: ExtendedProductApprovalDto.productApprovalState;
    /**
     * Indicates whether the requested sheet is already approved in the pre product.
     */
    readonly sheetApprovedInPreproduct?: boolean;
};
export namespace ExtendedProductApprovalDto {
    export enum processTypeIdentifier {
        INITIAL_APPROVAL = 'INITIAL_APPROVAL',
        RENEWAL = 'RENEWAL',
        RENEWAL_APPROVAL = 'RENEWAL_APPROVAL',
        CHANGE_APPROVAL = 'CHANGE_APPROVAL',
        ADDITIONAL_FORMULATIONS = 'ADDITIONAL_FORMULATIONS',
        ADDITIONAL_SHEET = 'ADDITIONAL_SHEET',
        FORMULATION_CHANGE = 'FORMULATION_CHANGE',
        LEGACY_MIGRATION = 'LEGACY_MIGRATION',
    }
    export enum productTypeIdentifier {
        ORIGINAL = 'ORIGINAL',
        REBRAND = 'REBRAND',
        REBLEND = 'REBLEND',
        ALL = 'ALL',
    }
    export enum productApprovalState {
        TECHNICAL_EXAMINATION = 'TECHNICAL_EXAMINATION',
        RELEASE_ENGAGEMENT_CREATION = 'RELEASE_ENGAGEMENT_CREATION',
        SIGNED_RELEASE_ENGAGEMENT_MISSING = 'SIGNED_RELEASE_ENGAGEMENT_MISSING',
        REVIEW_OF_SIGNED_RELEASE_ENGAGEMENT = 'REVIEW_OF_SIGNED_RELEASE_ENGAGEMENT',
        INVOICE_CREATION = 'INVOICE_CREATION',
        INVOICE_REQUESTED = 'INVOICE_REQUESTED',
        INVOICE_SENT = 'INVOICE_SENT',
        INVOICE_OVERDUE = 'INVOICE_OVERDUE',
        CERTIFICATE_CREATION = 'CERTIFICATE_CREATION',
        APPROVAL_RELEASE = 'APPROVAL_RELEASE',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        CANCELLED = 'CANCELLED',
        REWORK_NECESSARY = 'REWORK_NECESSARY',
    }
}

